var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { PersonCell } from './person-cell';
import { useLang } from '../hooks/use-lang';
import { EntityValue } from './entity-value';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { EntityFollowControls } from './entity-follow-controls';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('entity-conversation-banner');
export var EntityConversationBannerDefaultProps = {
  showActiveEntity: true,
  showFollowControls: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme.UNIT(2), theme.COLOR('line-subtle')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid ", ";\n    padding: 0 ", " ", ";\n  "], ["\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid ", ";\n    padding: 0 ", " ", ";\n  "])), theme.COLOR('line-subtle'), theme.UNIT(0), theme.UNIT(3))
});
var ActiveConversationEntityStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FollowControlsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ModeratorStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityConversationBanner',
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ActiveConversationEntity: styled(EntityValue)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ActiveConversationEntityStyles),
  FollowControls: styled(EntityFollowControls)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FollowControlsStyles),
  Moderator: styled(PersonCell)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ModeratorStyles)
};
export var EntityConversationBanner = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityConversationBannerDefaultProps, props);
  var entity = componentProps.entity,
    className = componentProps.className,
    showActiveEntity = componentProps.showActiveEntity,
    showFollowControls = componentProps.showFollowControls;
  // const definition = useEntityDefinition(entity);
  var entityType = entityTypeNameFor(entity);
  // const title = sprintf(baseTemplate, definition.label);
  var t = useLang();
  return React.createElement(My.Container, {
    className: className
  }, showActiveEntity && React.createElement(My.ActiveConversationEntity, {
    entity: entity
  }), showFollowControls && React.createElement(My.FollowControls, {
    entity: entity
  }));
};
EntityConversationBanner.defaultProps = EntityConversationBannerDefaultProps;
EntityConversationBanner.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;